import React from "react";
import { Divider } from "common/components/listItems/Divider";
import { HazardousObjectIndexed } from "../../../types/api.types";
import { HazardousObjectCard } from "./HazardousObjectCard";

interface PropertyHazardousObjectsListProps {
  hazardousObjects: HazardousObjectIndexed[];
}

export const PropertyHazardousObjectsList: React.FC<
  PropertyHazardousObjectsListProps
> = ({ hazardousObjects }) => (
  <div style={{ marginTop: "20px" }}>
    {hazardousObjects.map((hazardousObject) => (
      <div key={hazardousObject.index} style={{ marginBottom: "20px" }}>
        <HazardousObjectCard
          hazardousObject={hazardousObject}
          objectNumber={hazardousObject.index + 1}
        />
        <Divider style={{ marginTop: "10px" }} />
      </div>
    ))}
  </div>
);
